export { ProjectionPage as default } from '@/components/pages/Ir/Library/Projection'
